enum WidgetTemplateFieldNames {
  // Widget kind selector
  Kind = 'kind',
  PreviewButton = 'previewButton',

  // Announcement widget fields
  AnnouncementSettingsTitle = 'announcementSettingsTitle',
  BackgroundColor = 'backgroundColor',
  Content = 'content',
  Image = 'image',

  // External link widget fields
  ExternalLinkSettingsTitle = 'externalLinkSettingsTitle',
  Link = 'link',

  // Widget details fields
  WidgetDetailsTitle = 'widgetDetailsTitle',
  Title = 'title',
  Description = 'description',
  IconImage = 'iconImage',

  // Visibility fields
  IsPrivate = 'isPrivate',
}

export default WidgetTemplateFieldNames;
